import React from "react";

import CloseIcon from "../../../assets/images/close-icon.svg";
import { getTranslation } from "../../../helpers/getLanguage";
import Dialog from "../Dialog";
import styles from "./DeletionWaitingModal.module.css";

const DeletionWaitingModal = ({
  closeDialog,
  message = getTranslation("DELETION_WAITING_DEFAULT_MESSAGE"),
  closeOnClickOutside = false,
  closeOnEscape = false,
  hideCloseIcon = true,
  messageWidth = 0,
  messageHeight = 0,
  className,
  textContainerClass,
}) => {
  const handleCloseDialog = () => {
    closeDialog && closeDialog();
  };

  const popupTextStyles = {};
  if (messageWidth) {
    popupTextStyles.width = messageWidth;
  }
  if (messageHeight) {
    popupTextStyles.minHeight = messageHeight;
  }

  return (
    <Dialog closeDialog={closeDialog} closeOnClickOutside={closeOnClickOutside} closeOnEscape={closeOnEscape}>
      <div className={`${styles.deletePopup} ${className ? className : ""}`}>
        <div className={`${styles.deletePopupClose} flex width-100`}>
          {!hideCloseIcon && <img src={CloseIcon} alt="" className="pointer" onClick={handleCloseDialog} />}
        </div>

        <div className="flex-center height-100">
          <div className="flex-column align-center">
            <span
              className={`${styles.deletePopupText} ${textContainerClass ? textContainerClass : ""}`}
              style={popupTextStyles}
            >
              {message}
            </span>
            <div className={styles.loadingSpinner} />
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default DeletionWaitingModal;
